import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Jan 14 2019
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from "mobx";
import { KpiEngineSetKeyEnum, KpiRecord } from '@logio/common-be-fe';
import { KpiLayer } from '../../transportLayers/kpi/KpiLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * Persistent store for WindowFile
 */

export var KpiStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(KpiStore, _BaseStore);

  function KpiStore() {
    var _this;

    _classCallCheck(this, KpiStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KpiStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.Kpi;
    /** Layer contains methods for fetching data */

    _this.kpiLayer = new KpiLayer();
    /** List of KpiRecords */

    _this.records = new Map();
    /** List of KpiDescriptions */

    _this.descriptions = new Map();
    return _this;
  }
  /**
   * Gets KPI record detail for provided KPI set.
   * @param specs - array of IKpiRecordSetSpec
   * @returns Promise with KpiRecord
   */


  _createClass(KpiStore, [{
    key: "getRecordsDetail",
    value: function getRecordsDetail(specs) {
      var _this2 = this;

      return this.kpiLayer.findRecords(specs).then(function (records) {
        _this2.records.clear();

        runInAction(function () {
          _this2.detail = records[0]; // records.forEach((record: KpiRecord) => {
          //   this.records = this.records.set(record.kpiId, record);
          // });
        });
        return records[0];
      });
    }
  }, {
    key: "getDescriptions",

    /**
     * Retrieves set of available KPIs
     * @returns Promise with KpiDescription list
     */
    value: function getDescriptions() {
      var _this3 = this;

      return this.kpiLayer.findDescriptions().then(function (descriptions) {
        _this3.descriptions.clear();

        runInAction(function () {
          descriptions.forEach(function (description) {
            _this3.descriptions = _this3.descriptions.set(description.tag, description);
          });
        });
        return descriptions;
      });
    }
  }, {
    key: "getSets",

    /**
     * Gets all KPI sets for provided KPI set.
     * @param setPeerType - Entity name [SessionInfo, Promotion]
     * @param setPeerId - id based on peerType [session.id, promotion.id]
     * @param setKey - defined key from KpiEngineSetKeyEnum
     * @returns Promise with KpiRecord[]
     */
    value: function getSets(setPeerType, setPeerId, setKey) {
      var _this4 = this;

      return this.kpiLayer.findSets(setPeerType, setPeerId, setKey).then(function (records) {
        _this4.records.clear();

        runInAction(function () {
          records.forEach(function (record) {
            _this4.records = _this4.records.set(record.kpiId, record);
          });
        });
        return records;
      });
    }
  }, {
    key: "getRecords",

    /**
     * Gets all KPI records for provided KPI set.
     * @param specs - array of IKpiRecordSetSpec
     * @returns Promise with KpiRecord[]
     */
    value: function getRecords(specs) {
      var _this5 = this;

      return this.kpiLayer.findRecords(specs).then(function (records) {
        _this5.records.clear();

        runInAction(function () {
          records.forEach(function (record) {
            _this5.records = _this5.records.set(record.kpiId, record);
          });
        });
        return records;
      });
    }
  }]);

  return KpiStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", KpiRecord)], KpiStore.prototype, "detail", void 0);

__decorate([observable, __metadata("design:type", Map)], KpiStore.prototype, "records", void 0);

__decorate([observable, __metadata("design:type", Map)], KpiStore.prototype, "descriptions", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Promise)], KpiStore.prototype, "getRecordsDetail", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], KpiStore.prototype, "getDescriptions", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, String, String]), __metadata("design:returntype", Promise)], KpiStore.prototype, "getSets", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Promise)], KpiStore.prototype, "getRecords", null);